import { medicalsApi } from "../api/medicalsApi";
import { QueryKeys } from "../constants/queryKeys";
import { AllergiesQuery } from "../hooks/useAllergies";
import { queryClient } from "../queryClient";

export const AllergiesManager = {
  getPatientAllergies: (query: AllergiesQuery) => {
    return queryClient.fetchQuery({
      queryKey: [QueryKeys.ALLERGIES],
      queryFn: () => medicalsApi.findAllergies(query),
    });
  },

  invalidate: () =>
    queryClient.invalidateQueries({ queryKey: [QueryKeys.ALLERGIES] }),
};
